module.exports = __webpack_public_path__ + "img/fittingRoom.7051ca67.jpg";